import { useEffect, useState } from "react";

type Breakpoint = "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | null;

export const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>(null);

  useEffect(() => {
    const getBreakpoint = () => {
      const width = window.innerWidth;

      if (width < 640) return "xs";
      if (width < 768) return "sm";
      if (width < 1024) return "md";
      if (width < 1280) return "lg";
      if (width < 1536) return "xl";
      return "2xl";
    };

    const handleResize = () => {
      setBreakpoint(getBreakpoint());
    };

    handleResize(); // 초기 렌더에서 한 번 실행
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    breakpoint,
    desktopMode: breakpoint ? ["xl", "2xl"].indexOf(breakpoint) >= 0 : false,
    mobileMode: breakpoint ? ["xs"].indexOf(breakpoint) >= 0 : false,
    miniMode: breakpoint ? ["xs", "sm"].indexOf(breakpoint) >= 0 : false,
    tabletMode: breakpoint ? ["sm", "md"].indexOf(breakpoint) >= 0 : false,
  };
};
